var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { css, mq, styled } from "../../../utils";
var StyledFooter = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: ", ";\n\n    button:first-of-type {\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n\n    button {\n      color: ", ";\n      border-color: ", ";\n\n      svg {\n        margin: 0 0.5rem;\n        vertical-align: text-top;\n      }\n\n      path {\n        fill: ", ";\n      }\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: ", ";\n\n    button:first-of-type {\n      svg {\n        transform: rotate(180deg);\n      }\n    }\n\n    button {\n      color: ", ";\n      border-color: ", ";\n\n      svg {\n        margin: 0 0.5rem;\n        vertical-align: text-top;\n      }\n\n      path {\n        fill: ", ";\n      }\n    }\n  "])), colors.primary, colors.white, colors.white, colors.white);
}, mq({
    height: ['60px', '80px'],
}));
var Footer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(StyledFooter, __assign({}, props), children));
};
export default Footer;
var templateObject_1;
//# sourceMappingURL=Footer.js.map